export default {
  SET_VIEWPORT: '@SHELL_SET_VIEWPORT',
  SET_USER: '@AUTH_SET_USER',
  SIGN_OUT: '@AUTH_SIGN_OUT',

  SET_ACTIVE_USER_AD_GROUP: '@SHELL_SET_ACTIVE_USER_AD_GROUP',
  RESET_ACTIVE_USER_AD_GROUP: '@SHELL_RESET_ACTIVE_USER_AD_GROUP',
  GET_USER: '@SHELL_GET_USER',

  HIDE_GLOBAL_NAVIGATION: '@HIDE_GLOBAL_NAVIGATION',
  SHOW_GLOBAL_NAVIGATION: '@SHOW_GLOBAL_NAVIGATION',

  ADD_NOTIFICATION: '@SHELL_ADD_NOTIFICATION',
  CLEAR_NOTIFICATION: '@SHELL_CLEAR_NOTIFICATION',
};
